import {
  StyleBannerWrapper,
  StyleBannerImageWrapper,
  StyleProfileInfoWrapper,
  StyleProfileNameWrapper,
  StyleTagsWrapper,
  StyleTag,
} from './style'
import Image from '@components/image'
import Row from '@components/row'
import Button from '@components/button'
import Typography from '@components/typography'
import Svg from '@components/svg'
import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Banner = () => {
  const navigate = useNavigate()
  const { data: user } = useSelector((state: any) => state.user)
  const tags = [
    {
      title: `${user?.infos?.yos} Years of Service`,
      icon: 'medal',
    },
    {
      title: user?.departments[0]?.name,
      icon: 'plusHeart',
    },
  ]
  return (
    <StyleBannerWrapper>
      <StyleBannerImageWrapper>
        <Image src={`${process.env.BUCKET_URL}/${user?.infos?.coverImage}`} />
      </StyleBannerImageWrapper>
      <StyleProfileInfoWrapper>
        <Row alignItems="flex-end" justifyContent="space-between">
          <Image
            src={`${process.env.BUCKET_URL}/${user?.avatar}`}
            width={100}
            height={100}
            styleImage="border-radius:4px"
          />
          <Row colGap={5} alignItems="center">
            <Svg svg="location" size={14} color={'text'} />
            <Typography content={user?.infos?.address} size={14} tc="text" />
          </Row>
        </Row>
        <StyleProfileNameWrapper>
          <Row alignItems="center" colGap={10}>
            <Typography content={user?.name} size={20} weight={400} tc="text" />
            {!!user?.isApproved && <Svg svg="verified" size={30} />}
          </Row>
          <Row alignItems="center" colGap={5}>
            <Svg svg="star" color="secondary" size={24} />
            <Typography content={'4.5'} size={20} weight={400} tc="text" />
          </Row>
        </StyleProfileNameWrapper>
        <StyleTagsWrapper>
          <Row colGap={10} rowGap={5}>
            {tags?.map((tag: any, index: number) => {
              return (
                <Fragment key={index}>
                  <StyleTag>
                    {!!tag?.icon && <Svg svg={tag?.icon} />} {tag?.title}
                  </StyleTag>
                </Fragment>
              )
            })}
          </Row>
          <Row colGap={20}>
            <Button
              height={45}
              leftComponent={<Svg svg="direction" color={'primary'} />}
              outline
              title="Get Directions"
            />
            <Button
              height={45}
              leftComponent={<Svg svg="edit" color={'white'} />}
              title="Edit Profile"
              onClick={() => {
                navigate(`/${user?.role}/profile/edit`)
              }}
            />
          </Row>
        </StyleTagsWrapper>
      </StyleProfileInfoWrapper>
    </StyleBannerWrapper>
  )
}

export default Banner
